<template>
  <div>
    <pc-bread-crumb :data="articleData.breadcrumbs" />
    <div class="wf-hero-banner">
      <pc-responsive-image
        :desktopSrc="articleData.desktopSrc.replace('~', '')"
        :mobileSrc="articleData.mobileSrc.replace('~', '')"
        :imageAlt="articleData.alt"
        :imageCss="'background-image'"
      />
    </div>
    <pc-backand-share-button />
    <!-- <pc-article-details :articleData="articleData" />

    <wf-article-listing :settings="articleData.relatedArticles" />

    <pc-article-previous-next
      :previousArticle="articleData.previousArticle"
      :nextArticle="articleData.nextArticle"
    /> -->
  </div>
</template>

<script>
import PcBreadCrumb from "../common/pc-bread-crumb.vue";
import PcResponsiveImage from "./../common/pc-responsive-image.vue";
import PcBackandShareButton from "./../common/pc-backand-share-button.vue";
import PcArticleDetails from "./pc-article-details.vue";
import wfArticleListing from "./../wf-article-listing.vue";
import PcArticlePreviousNext from "./pc-article-previous-next.vue";
export default {
  props: ["articleData"],
  components: {
    PcBreadCrumb,
    PcResponsiveImage,
    PcBackandShareButton,
    PcArticleDetails,
    wfArticleListing,
    PcArticlePreviousNext
  }
};
</script>
